import {DateTime, IResult, Result} from "@2d-front-monorepo/core";
import CreditCardProvider from "../enums/CreditCardProvider.js";
import FeeDisplayLayout from "../enums/FeeDisplayLayout.js";
import {ParkingOperationStep, parkingOperationStepFactory} from "./ParkingOperationStep.js";
import {PriceBreakdown} from "./Price";

export interface ListParkingTariffResult {
	creditCardProvider: CreditCardProvider
	totalPrice: PriceBreakdown;
	layout: FeeDisplayLayout;
	postPay: boolean;
	operations: IResult<ParkingOperationResult>[];
	deferredConfirmation?: string | undefined;
}

export interface ParkingOperationResult {
	startDate: DateTime;
	confirmationGuid: string;
	plates: string[];
	steps: ParkingOperationStep[];
}

export function buildParkingOperationResult(startDate: DateTime, endDate?: DateTime): ParkingOperationResult {
	return {
		startDate: startDate,
		steps: endDate == null ? [] : [parkingOperationStepFactory(endDate)],
		confirmationGuid: "",
		plates: []
	}
}

export function buildParkingTariffResult(startDate: DateTime, endDate?: DateTime): ListParkingTariffResult {
	return {
		creditCardProvider: CreditCardProvider.Undefined,
		postPay: false,
		totalPrice: {
			wallet: 0,
			totalToPay: 0,
			vatBreakdown: [],
			amount: 0,
			amountPlusVat: 0,
			amountWithoutBonification: 0,
			realAmount: 0,
			vat: 0,
			fee: 0,
			feePlusVat: 0,
			subtotal: 0,
			total: 0,
			bonification: 0,
			time: 0,
			timeBalanceUsed: 0
		},
		layout: FeeDisplayLayout.NoFee,
		operations: [Result.fromValue(buildParkingOperationResult(startDate, endDate))]
	}
}
